import { render } from "./TheCookieBanner.vue?vue&type=template&id=6a6c482d"
const script = {}

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__